import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, computed, useContext } from "@nuxtjs/composition-api";
import { useMobile } from "~/core/composables/useMobile";
import { ACTIONS as TOAST_ACTIONS } from "~/store/affility/user/feedback/modals/toast-notification/names";
import MunicipalityTx from "~/core/models/purchase-popup-2/MunicipalityTx";
import Web3MunicipalityTx from "~/core/models/purchase-popup-2/Web3MunicipalityTx";
import PROVIDERS from "~/constants/providers";

interface Props {
    canBuyFor: any,
    transactionObject: MunicipalityTx | Web3MunicipalityTx,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Web3WalletConnection',
  props: {
    canBuyFor: null,
    transactionObject: null
  },
  emits: ['onStartLoading', 'onStopLoading', 'onWalletConnectionDone', 'onClickBack'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { canBuyFor: any, transactionObject: MunicipalityTx | Web3MunicipalityTx };





const {
    canBuyFor,
    transactionObject,
} = toRefs(props);

const isMobile = useMobile();
const { $createWeb3Provider, $enableProvider, i18n, store } = useContext();

const isWalletIncorrect = ref(false);
const walletConnectionError = ref(null);

const providers = computed(() => {
    let identifier = null;
    return PROVIDERS.filter((provider) => {
        if (provider.isInstalled && !provider.isInstalled()) {
            return false;
        }
        if (window.ethereum && provider.identifier) {
            identifier = window.ethereum[provider.identifier];
        }
        return (
            provider.providerName !== "injected" || identifier
        );
    });
})

const handleConnect = async (index: number) => {
    const { providerName } = providers.value[index];
    $emit('onStartLoading');
    let provider = null;
    let addresses = null;
    walletConnectionError.value = null;
    try {
        try {
            const providerData = await $createWeb3Provider(providerName, false);
            provider = providerData.providerObject;
            addresses = await $enableProvider(providerData);
            if (canBuyFor.value) {
                try {
                    const localCanBuyFor = await canBuyFor.value(transactionObject.value.owner, addresses[0]);
                    if (!localCanBuyFor) {
                        isWalletIncorrect.value = true;
                        $emit('onStopLoading');
                        return;
                    }
                } catch (e) {
                    isWalletIncorrect.value = true;
                    walletConnectionError.value = e.message;
                    $emit('onStopLoading');
                    return;
                }
            }
        } catch (e) {
            if (e.code !== 4001) {
                throw e;
            } else {
                $emit('onStopLoading');
                return;
            }
        }
        $emit('onWalletConnectionDone', addresses[0], provider);
    } catch (e) {
        store.dispatch(`affility/user/feedback/modals/toast-notification/${TOAST_ACTIONS.SHOW_ERROR_TOAST}`, {
            description: i18n.t('Something went wrong, please refresh the page and try again'),
        })
        $emit('onStopLoading');
    }
}

return { __sfc: true,props, $emit, canBuyFor, transactionObject, isMobile, $createWeb3Provider, $enableProvider, i18n, store, isWalletIncorrect, walletConnectionError, providers, handleConnect }
}

})